import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';

import { Container, CheckLabel, Content, ErrorMessage } from './styles';

export default function Checkbox({
  name,
  color = 'primary',
  columns = '1fr 1fr 1fr',
  disabled = false,
  handleSelected,
  options,
  errorField,
}) {
  const inputRefs = useRef([]);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRefs.current,
      getValue(refs) {
        const filterArr = refs.filter(ref => ref.checked);
        const arr = filterArr.map(ref => (ref.checked ? ref.value : null));
        return arr;
      },
      setValue: (refs, values) => {
        refs.forEach(ref => {
          if (values) {
            // ESSE IF FAZ O BOTAO COMERCIAIS SEM PLANILHA FUNCIONAR
            if (values[0] && values[0].id === Number(ref.value)) {
              ref.checked = true;
            } else {
              ref.checked = false;
            }

            // NÃO SEI PARA QUE SERVE ESSE IF
            if (values.includes(ref.value.id)) {
              ref.checked = true;
            }
            // ESSE IF FAZ O BOTÃO REDE FUNCIONAR
            if (values.includes(ref.value)) {
              ref.checked = true;
            }
          }
        });
      },

      clearValue: refs => {
        refs.forEach(ref => {
          ref.checked = false;
        });
      },
    });
  }, [fieldName, registerField]);
  return (
    <Container>
      <Content
        $columns={columns}
        color={color}
        $error={error ? 'true' : 'false' && errorField ? 'true' : 'false'}
      >
        {options.map((option, index) => (
          <label key={option.id}>
            <input
              ref={elRef => (inputRefs.current[index] = elRef)}
              type="checkbox"
              id={`checkbox_id_${name}_${index}`}
              name={fieldName}
              value={option.id}
              defaultChecked={
                defaultValue && defaultValue.length > 0
                  ? defaultValue.find(value => value === option.id)
                  : null
              }
              disabled={disabled}
              onClick={e => {
                if (!disabled && handleSelected)
                  handleSelected({ e, ...option, checked: e.target.checked });
              }}
            />

            <CheckLabel htmlFor={`checkbox_id_${name}_${index}`}>
              {option.label}
            </CheckLabel>
          </label>
        ))}
      </Content>
      <ErrorMessage>{error || errorField}</ErrorMessage>
    </Container>
  );
}

// Checkbox.defaultProps = {
//   color: 'primary',
//   columns: '1fr 1fr 1fr',
//   disabled: false,
//   handleSelected: () => null,
// };

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  errorField: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  columns: PropTypes.string,
  handleSelected: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      label: PropTypes.string,
    }).isRequired,
  ),
};
